import { render, staticRenderFns } from "./Alianza.vue?vue&type=template&id=a978340e"
import script from "./Alianza.vue?vue&type=script&lang=js"
export * from "./Alianza.vue?vue&type=script&lang=js"
import style0 from "./Alianza.vue?vue&type=style&index=0&id=a978340e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports